import Alpine from "alpinejs";

const { CUSTOMER_EMAIL, SHOPIFY_DOMAIN, GLOBALS } = window;

export const alpineStoreMerchant = () =>
  Alpine.store("merchant", {
    shopifyDomain: SHOPIFY_DOMAIN,
    customerEmail: CUSTOMER_EMAIL,
    globals: GLOBALS,
  });
